import { useCallback, useEffect, useState } from 'react';
import { useRouter, useTranslation, navigate, Notification } from '@sms/plasma-ui';
import app from '../../config/app.json';
import { booksApi } from "../../services";

type BookData = { icon: string; name: string; features: string[]; bookDeletePermission: boolean };

interface BookToDelete {
    id: number;
    name: string;
}

export function usePageWithBookEditMenu() {
    const { route } = useRouter('route');
    const { t } = useTranslation();
    const [bookData, setBookData] = useState<BookData>({ icon: "", name: "", features: [], bookDeletePermission: false });
    const [bookToDelete, setBookToDelete] = useState<BookToDelete | null>(null);

    useEffect(() => {
        const bookId = route.params.bookId;
        if (bookId === "master") { return; }

        booksApi.getBook(Number(bookId))
            .then((data) => {
                if (!data) {
                    bookNotFound();
                    return;
                }

                const bookIcon = data?.Icon ?? "";
                const bookName = data?.Name ?? "";
                const bookFeatures = data?.Features ?? [];
                const bookDeletePermission = data?.IsOwner ? true : data?.PermissionLevel === "Admin" ? true : false;
                const newBookData = { icon: bookIcon, name: bookName, features: bookFeatures, bookDeletePermission: bookDeletePermission };
                setBookData(newBookData);

            })
            .catch(() => {
                bookNotFound();
            });
    }, [route.params?.bookId, t]);

    const bookNotFound = () => {
        const SUB_PATH = (window as any).plasma?.environment?.SUB_PATH ?? '/';
        const PROCESSED_SUB_PATH = SUB_PATH.replace(/\/$/, '');
        const notFoundPath = `${PROCESSED_SUB_PATH}/${app.code}/404`.replace(/\/\//g, '/');
        navigate(notFoundPath);
    }

    const handleDeleteBook = useCallback(async () => {
        if (!bookToDelete || bookToDelete.id === 0){
            Notification.error("books.page.card.delete.error")
            return;
        }

        booksApi.deleteBook(Number(bookToDelete.id))
            .then(() => {
                Notification.success("books.page.card.delete.success")
                setBookToDelete(null)
                navigate("../../../books", { relative: true });
            })
            .catch(() => {
                Notification.error("books.page.card.delete.error")
            });
    }, [bookToDelete]);

    return { 
        bookData,
        handleDeleteBook,
        bookToDelete,
        setBookToDelete,
    };
}
